import React from 'react'

export default function FaceFeature({ scaleX, fill, verticalOffset }) {
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <path d="M3.92 3.04016L7.84 0.160156H0L3.92 3.04016Z" fill={fill} />
    </g>
  )
}
